import moment from 'moment';
export default {
	getSearchMonths_({ searchParams: { strDt, endDt } }) {
		return [moment(strDt).format('YYYYMMDD'), moment(endDt).format('YYYYMMDD')];
	},
	getSndStCdListFiltered_({ sndStCdList }) {
		return sndStCdList.filter(el => el.value === 'NSND' || el.value === 'ET_FAIL'); //ET_FAIL : 발송실패, NSND : 미발송
	},
	gridUseYnList_({ useYnList }) {
		const list = [];
		useYnList.length && useYnList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//유형 selectBox
	getPartClList_({ partClList }) {
		const list = [];
		partClList.length && partClList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//종합판정 selectBox
	getOvrlJgmtCdList_({ ovrlJgmtCdList }) {
		const list = [];
		ovrlJgmtCdList.length && ovrlJgmtCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사상태 selectBox
	getPgsStPcCdList_({ pgsStPcCdList }) {
		const list = [];
		pgsStPcCdList.length && pgsStPcCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사상태(LP용) selectBox
	getPgsStLpCdList_({ pgsStLpCdList }) {
		const list = [];
		pgsStLpCdList.length && pgsStLpCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사상태(KD용) selectBox
	getPgsStKdCdList_({ pgsStKdCdList }) {
		const list = [];
		pgsStKdCdList.length && pgsStKdCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//진행상태 selectBox
	getPgsStLpCdList_({ pgsStLpCdList }) {
		const list = [];
		pgsStLpCdList.length && pgsStLpCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//긴급도 selectBox
	getLugyCdList_({ lugyCdList }) {
		const list = [];
		lugyCdList.length && lugyCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//불량유형 selectBox
	getBadTypeLgrpList_({ badTypeLgrpCdList }) {
		const list = [];
		badTypeLgrpCdList.length && badTypeLgrpCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//발생장소 selectBox
	getOccuPlCdList_({ occuPlCdList }) {
		const list = [];
		occuPlCdList.length && occuPlCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//고품처리 selectBox
	getRptpPrcsCdList_({ rptpPrcsCdList }) {
		const list = [];
		rptpPrcsCdList.length && rptpPrcsCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//대책회신 selectBox
	getMdvRplCdList_({ mdvRplCdList }) {
		const list = [];
		mdvRplCdList.length && mdvRplCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//소싱구분 selectBox
	getPartGCdList_({ partGCdList }) {
		const list = [];
		partGCdList.length && partGCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//메일전송상태 selectBox
	getSndStCdList_({ sndStCdList }) {
		const list = [];
		sndStCdList.length && sndStCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//클래임 진행상태 selectBox
	getClmPgsStCdList_({ clmPgsStCdList }) {
		const list = [];
		clmPgsStCdList.length && clmPgsStCdList.forEach(row => list.push({ label: row.codeName, value: row.code }));
		return list;
	},
	//판정결과 selectBox
	getClmRsltCdList_({ clmRsltCdList }) {
		const list = [];
		clmRsltCdList.length && clmRsltCdList.forEach(row => list.push({ label: row.codeName, value: row.code }));
		return list;
	},
	//판정진행상태 selectBox
	getJudgedStateList_({ judgedStateList }) {
		const list = [];
		judgedStateList.length && judgedStateList.forEach(row => list.push({ label: row.codeName, value: row.code }));
		return list;
	},
	//운송수단 selectBox
	getTpWayCdList_({ tpWayCdList }) {
		const list = [];
		tpWayCdList.length && tpWayCdList.forEach(row => list.push({ label: row.codeName, value: row.code }));
		return list;
	},
	//클래임 유형 selectBox
	getClmTypeGlsCdList_({ clmTypeGlsCdList }) {
		const list = [];
		clmTypeGlsCdList.length && clmTypeGlsCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//clm 발생장소  selectBox
	getClmOccuPlCdList_({ clmOccuPlCdList }) {
		const list = [];
		clmOccuPlCdList.length && clmOccuPlCdList.forEach(row => list.push({ label: row.codeName, value: row.code }));
		return list;
	},
	// form전송을 하기위해 formData에 setting
	detailFormData_({ detailForm }, getters) {
		const formData = new FormData();

		for (const [key, val] of Object.entries(detailForm)) {
			if (!val) continue;
			else if (key === 'badFile' || key === 'badCausFile') {
				val.length ? val.forEach(file => formData.append(key, file)) : formData.append(key, '');
			} else if (key === 'normImgFile' || key === 'badImgFile') {
				formData.set(key, val);
			} else formData.append(key, val);
		}

		// //이메일 정보취합
		// const apcn = getters.detailEmail_;
		// formData.set('rcptNm', apcn.rcptNm);
		// formData.set('rcptAdr', apcn.rcptAdr);
		// formData.set('rfpNm', apcn.rfpNm);
		// formData.set('rfpAdr', apcn.rfpAdr);

		return formData;
	},
	//엑셀 다운로드 컬럼
	getExcelColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001034'), //ppr번호
				prop: 'pprNo',
				minWidth: '250px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001438'), //제목
				prop: 'badTitlSbc',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001382'), //작성자
				prop: 'mdvPprrNm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001094'), //진행상태
				prop: 'pgsStNm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000958'), //협력사명
				prop: 'cofNm',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000981'), //소싱구분
				prop: 'partGCd',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000956'), //품번
				prop: 'partNo',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000957'), //품명
				prop: 'partNm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001418'), //긴급도
				prop: 'lugyCd',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000069'), //유형
				prop: 'badTypeLgrpNm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001419'), //라인정지 시간
				prop: 'lnStpTm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000074'), //라인정지 시간
				prop: 'badQty',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001954'), //불량수량
				prop: 'sprtQty',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001455'), //고품처리
				prop: 'rptpPrcsCd',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001436'), //대책 회신
				prop: 'mdvRplCd',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001444'), //대책일자
				prop: 'mdvDd',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001460'), //조치처
				prop: 'rcptNm',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001032'), //발생일자
				prop: 'occuDd',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001413'), //제기일
				prop: 'pprsDd',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001420'), //회신요구일
				prop: 'rplRqDd',
				minWidth: '200px'
			}
		];
	}

	// detailEmail_({ rcptInfo, rfpInfo }) {
	// 	/**이메일 정보 취합 */
	// 	let rcptNm = '',
	// 		rcptAdr = '',
	// 		rfpNm = '',
	// 		rfpAdr = '';
	// 	if (rcptInfo.size > 0) {
	// 		for (const [key, val] of rcptInfo) {
	// 			rcptNm += val + ';';
	// 			rcptAdr += key + ';';
	// 		}
	// 	}
	// 	if (rfpInfo.size > 0) {
	// 		for (const [key, val] of rfpInfo) {
	// 			rfpNm += val + ';';
	// 			rfpAdr += key + ';';
	// 		}
	// 	}
	// 	return {
	// 		rcptNm: rcptNm.substring(0, rcptNm.length - 1),
	// 		rcptAdr: rcptAdr.substring(0, rcptAdr.length - 1),
	// 		rfpNm: rfpNm.substring(0, rfpNm.length - 1),
	// 		rfpAdr: rfpAdr.substring(0, rfpAdr.length - 1)
	// 	};
	// }
};
